import { Box, styled } from "@mui/material"
import { COLORS } from "../../ui/Theme"
import logo from '../../assets/img/logo.png'
import { Link, useNavigate } from "react-router-dom"
import Logo from "../../components/logo/Logo"

const HeaderBox = styled('div')({
    position: "sticky",
    top: 0,
    zIndex: 10,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px",
    backgroundColor: COLORS.WHITE,
    borderBottom: `1px solid ${COLORS.SOFTGRAY}`

})

const Header = () => {
    const navigate = useNavigate()

    const login = async () => {
        navigate("dashboard")
    }

    return (
        <HeaderBox>
            <Logo />
            <Box>
                <button onClick={login} className="btn btn-blue">ورود به سامانه</button>
            </Box>
        </HeaderBox>
    )
}

export default Header